export interface FacetOption {
  value: string;
  label: string;
}

export interface FacetDef {
  key: string;
  label: string;
  options: FacetOption[];
}

export interface SortOption {
  value: string;
  label: string;
}

export interface CloudFilters {
  query: string;
  facets: Record<string, string[]>;
  sort: string;
}

export const EMPTY_FILTERS: CloudFilters = { query: '', facets: {}, sort: '' };

export function hasActiveFilters(f: CloudFilters): boolean {
  return !!f.query || Object.values(f.facets).some(v => v.length > 0);
}

export function parseFiltersFromParams(
  params: Record<string, string>,
  defaultSort: string,
  facetKeys: string[],
): CloudFilters {
  const facets: Record<string, string[]> = {};
  for (const key of facetKeys) {
    const val = params[key];
    if (val) facets[key] = val.split(',').filter(Boolean);
  }
  return {
    query: params['q'] ?? '',
    sort:  params['sort'] ?? defaultSort,
    facets,
  };
}

export function filtersToParams(
  f: CloudFilters,
  facetKeys: string[],
): Record<string, string | null> {
  const params: Record<string, string | null> = {
    q:    f.query || null,
    sort: f.sort  || null,
  };
  for (const key of facetKeys) {
    const vals = f.facets[key] ?? [];
    params[key] = vals.length ? vals.join(',') : null;
  }
  return params;
}
